<template>
  <div class="evolucion-rn">
    <div class="dashboard-chart">
      <h4>Evolución de Conceptos de la RN</h4>
      <p class="description">Evolución de la participación sobre las ventas de los conceptos incluidos en el cálculo de la RN</p>
    </div>
    <line-evolucion
      chartId="evolucion-rn" 
      class="chart-wrapper"
      ref="evolucionRN"
      :stepSize="parseInt(10)"
      :max="parseInt(120)"
      :yAxisCurrency="false"
      :yAxisPercentaje="true">
    </line-evolucion>

  <!-- <div class="dashboard-tabla-resultados">
    <div class="dashboard-tabla-resultados-data">
        <b-table hover
            responsive="sm" 
            class="table-dashboard"
            :busy="tableBusy"
            :items="resultadosEvolucion" 
            :fields="fields">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>              
          <template v-slot:cell(periodo)="data">
            {{ data.item.periodo | periodo }}
          </template>
          <template v-slot:cell(ventas)="data">
            {{ data.item.ventas | moneda }}
          </template>
          <template v-slot:cell(compras)="data">
            {{ data.item.compras | moneda }}
          </template>
          <template v-slot:cell(gastos)="data">
            {{ data.item.gastos | moneda }}
          </template>
          <template v-slot:cell(impuestos)="data">
            {{ data.item.impuestos | moneda }}
          </template>
          <template v-slot:cell(sueldos)="data">
            {{ data.item.sueldos | moneda }}
          </template>
        </b-table>
      </div>
    </div> -->

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import LineEvolucion from '../../charts/LineEvolucion.vue';
import Mensaje from  '../../shared/msjModal.vue';
import { msjModal } from '../../../mixins/modalDialogs'

export default {
  name: 'DashboardEvolucionRN',
  components: {
    LineEvolucion,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      resultadosEvolucion: [],

      fields: [
        { key: 'periodo' },
        {
          key: 'ventas',
          class: 'text-right',
        },
        {
          key: 'compras',
          class: 'text-right',
        },
        {
          key: 'gastos',
          class: 'text-right',
        },
        {
          key: 'impuestos',
          class: 'text-right',
        },
        {
          key: 'sueldos',
          class: 'text-right',
        },
      ],

      tableBusy: false,
      totalesEmpresa: false,

      // labels: [],
      // evolucionEmpresa: [],
      // evolucionEmpresaTabla: [],
      // evolucionEmpresaTotal: [],
      // evolucionEmpresaTotalTabla: [],
    }
  },
  methods: {
    getEvolucion() {
      this.$store.dispatch('resultadosAdministracion/getEvolucionRN')
        .then(() => {
          this.$refs.evolucionRN.render(this.$store.getters['resultadosAdministracion/resultadosEvolucionRNPeriodos'], 
            this.$store.getters['resultadosAdministracion/resultadosEvolucionRN']);
          // this.resultadosEvolucion = this.$store.getters['resultadosAdministracion/resultadosEvolucionEmpresaTotalTabla'];
        })
        .catch(error => this.showErrorMsj(error));
    },
  },
}
</script>

<style>
  .evolucion-rn .chart-wrapper {
    position: relative;
    height: 380px;
    margin-bottom: 30px;
  }
  /* .evolucion-rn .dashboard-tabla-resultados-data {
    min-height: 0 !important;
  } */

  .evolucion-rn .dashboard-chart h4 {
    margin-bottom: 5px;
  }
  .evolucion-rn .dashboard-chart p.description label {
    font-size: 1em;
    font-style: italic;
    cursor: pointer;
    margin-bottom: 5px;    
  }
</style>
